import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useDisplayedOrderNumber } from "../hooks/useDisplayedOrderNumber";
export var OrderNumber = function OrderNumber() {
  var orderNumber = useDisplayedOrderNumber();
  if (orderNumber) {
    return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraphSansMedium"
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "/FK2Ia",
      defaultMessage: "Order number"
    })), /*#__PURE__*/React.createElement(Spacer, {
      width: "1/2x"
    }), /*#__PURE__*/React.createElement(Typography, null, orderNumber));
  } else {
    return null;
  }
};